import { IconButton, Tooltip, TooltipProps } from '@chakra-ui/react';
import React from 'react';
import { useCurrentColors } from '../../hooks/UseCurrentColors/UseCurrentColors';

const CanopyTooltipIconButton = (
    props: {
        clickHandler: () => void;
        label: any;
        icon: React.ReactElement;
        arialLabel: string;
    } & Partial<TooltipProps>
) => {
    const currentColors = useCurrentColors();
    return (
        <Tooltip
            placement="bottom-start"
            hasArrow
            {...props}>
            <IconButton
                background="transparent"
                cursor="pointer"
                border="none"
                color={currentColors.whiteAlpha['400']}
                icon={props.icon}
                aria-label={props.arialLabel}
                onClick={props.clickHandler}
                variant="ghost"
                _hover={{
                    backgroundColor: 'transparent',
                }}
                _focus={{
                    border: '0px',
                    backgroundColor: 'transparent',
                    outline: 'none',
                }}
                _active={{
                    border: '0px',
                }}
            />
        </Tooltip>
    );
};

export default CanopyTooltipIconButton;
